import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const useSchema = () => {
  const { t } = useTranslation()

  const skierSchema = Yup.object().shape({
    name: Yup.string().required(t('general.validation.required')).max(255),
    age: Yup.number()
      .transform((value, original) => (original === '' ? undefined : value))
      .required(t('general.validation.required'))
      .min(0)
      .integer(),
  })

  return Yup.object().shape({
    lessonType: Yup.string().required().oneOf(['private', 'group']),
    discipline: Yup.string().required().oneOf(['ski', 'snowboard']),
    level: Yup.string().required().oneOf(['complete_beginner', 'beginner', 'intermediate', 'upper_intermediate']),
    date: Yup.string().required(),
    time: Yup.string().required(),
    customerId: Yup.string().required(),
    customerName: Yup.string().optional().default(''),
    notes: Yup.string().optional().default(''),
    skiers: Yup.array().of(skierSchema).min(1).required(),
    status: Yup.string().optional().oneOf(['new', 'rejected', 'in_progress', 'done']),
  })
}

export type RequestFormValues = Yup.InferType<ReturnType<typeof useSchema>>
